/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ConsumptionExpenseEntryMode = (typeof ConsumptionExpenseEntryMode)[keyof typeof ConsumptionExpenseEntryMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsumptionExpenseEntryMode = {
  aggregate: "aggregate",
  individual: "individual",
} as const;
